module.exports = __webpack_public_path__ + "img/settings.a1d69fce.svg";